<nav class="nav">
  <ul class="router-links">
    <li class="link" routerLink="" routerLinkActive="active">
      Credit Card Form
    </li>
    <li class="link" routerLink="credit-card-list" routerLinkActive="active">
      Credit Card List
    </li>
  </ul>
</nav>
